/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselPatternsResult
 */
export interface VesselPatternsResult {
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    rendevouzEventsDetected?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    visitedSanctionedPorts?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    stsTransfers?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    eezSkipping?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    suspectedOfIllegalFishing?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    collisionDetectAnalytics?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    groundingDetected?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    aisOff?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselPatternsResult
     */
    aisSpoofing?: any | null;
}

/**
 * Check if a given object implements the VesselPatternsResult interface.
 */
export function instanceOfVesselPatternsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselPatternsResultFromJSON(json: any): VesselPatternsResult {
    return VesselPatternsResultFromJSONTyped(json, false);
}

export function VesselPatternsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselPatternsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rendevouzEventsDetected': !exists(json, 'rendevouz_events_detected') ? undefined : json['rendevouz_events_detected'],
        'visitedSanctionedPorts': !exists(json, 'visited_sanctioned_ports') ? undefined : json['visited_sanctioned_ports'],
        'stsTransfers': !exists(json, 'sts_transfers') ? undefined : json['sts_transfers'],
        'eezSkipping': !exists(json, 'eez_skipping') ? undefined : json['eez_skipping'],
        'suspectedOfIllegalFishing': !exists(json, 'suspected_of_illegal_fishing') ? undefined : json['suspected_of_illegal_fishing'],
        'collisionDetectAnalytics': !exists(json, 'collision_detect_analytics') ? undefined : json['collision_detect_analytics'],
        'groundingDetected': !exists(json, 'grounding_detected') ? undefined : json['grounding_detected'],
        'aisOff': !exists(json, 'ais_off') ? undefined : json['ais_off'],
        'aisSpoofing': !exists(json, 'ais_spoofing') ? undefined : json['ais_spoofing'],
    };
}

export function VesselPatternsResultToJSON(value?: VesselPatternsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rendevouz_events_detected': value.rendevouzEventsDetected,
        'visited_sanctioned_ports': value.visitedSanctionedPorts,
        'sts_transfers': value.stsTransfers,
        'eez_skipping': value.eezSkipping,
        'suspected_of_illegal_fishing': value.suspectedOfIllegalFishing,
        'collision_detect_analytics': value.collisionDetectAnalytics,
        'grounding_detected': value.groundingDetected,
        'ais_off': value.aisOff,
        'ais_spoofing': value.aisSpoofing,
    };
}

